import { render, staticRenderFns } from "./ResponsibilityAssignmentHeader.vue?vue&type=template&id=bd29a524"
import script from "./ResponsibilityAssignmentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityAssignmentHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityAssignmentHeader.vue?vue&type=style&index=0&id=bd29a524&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports